import {withJsonFormsControlProps} from '@jsonforms/react';
import FileUploadController from './FileUploadController';
export default withJsonFormsControlProps(FileUploadController);
